import { render, staticRenderFns } from "./ForgotPassword.html?vue&type=template&id=8b7c9fa4&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPassword.scss?vue&type=style&index=0&id=8b7c9fa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c9fa4",
  null
  
)

export default component.exports